var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGrayCircle = function SvgGrayCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "351 0 17 17",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M353.5 8.496c0 4.618 4.999 7.507 9 5.196 1.855-1.07 3-3.05 3-5.196 0-4.618-4.999-7.503-9-5.196a6.006 6.006 0 0 0-3 5.196Z",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 3,
    stroke: "rgba(111,111,111,0.4 )",
    fill: "transparent",
    "data-name": "Path 280381"
  })));
};
export default SvgGrayCircle;